<!-- Pull-to-refresh Indicator (Solo Móvil) -->
<div class="pull-to-refresh-indicator" [class.refreshing]="isRefreshing"
    [style.transform]="'translateX(-50%) translateY(' + pullDistance + 'px)'"
    [style.opacity]="pullDistance > 10 ? 1 : 0">
    <i class="fas fa-sync-alt" [style.transform]="'rotate(' + (pullDistance * 4) + 'deg)'"></i>
</div>

<!-- Pantalla de carga mientras isLoading es true -->
<app-loading-screen *ngIf="loadingService.isLoading()"></app-loading-screen>

<!-- Aquí se renderizan los componentes según las rutas -->
<router-outlet></router-outlet>